import { openAuthModal } from "../../../common/authmodal/authmodalservice";
import { postEmergencyUnblind } from "../epsfService";

/**
 * Controlled emergency unblind: reason → re-auth → confirm → server reveal + audit.
 * Does not flip standing inventory unblinded access.
 */
export async function runEmergencyUnblind({
  studyId,
  siteId,
  participantId,
  impKitId,
  kitNumber,
  sourceContext = "ImpDispense",
}) {
  if (!studyId || !impKitId) {
    return { success: false, message: "Study and kit are required." };
  }

  const reason = window.prompt(
    `Emergency unblind for kit ${kitNumber || impKitId}.\nEnter clinical justification:`,
    "",
  );
  if (reason == null) {
    return { success: false, message: "Cancelled.", cancelled: true };
  }
  const trimmed = String(reason).trim();
  if (!trimmed) {
    return { success: false, message: "Justification is required." };
  }

  const auth = await openAuthModal({
    title: "Confirm emergency unblind",
    message: "Re-authenticate to reveal restricted treatment for this kit only.",
  });
  if (!auth || auth.cancelled || Number(auth.Success ?? auth.success ?? 0) !== 1) {
    return { success: false, message: "Re-authentication required.", cancelled: true };
  }

  const confirmed = window.confirm(
    `Reveal restricted treatment for kit ${kitNumber || ""}?\nThis creates an immutable audit entry.`,
  );
  if (!confirmed) {
    return { success: false, message: "Cancelled.", cancelled: true };
  }

  const result = await postEmergencyUnblind({
    StudyId: studyId,
    SiteId: siteId || null,
    ParticipantId: participantId || null,
    ImpKitId: impKitId,
    UnblindReason: trimmed,
    AuthResult: "Reauthenticated",
    AuthReference: String(auth.AuthReference || auth.Reference || auth.Token || "authmodal-ok").slice(
      0,
      200,
    ),
    SourceContext: sourceContext,
  });

  if (!result.success) {
    return { success: false, message: result.message || "Emergency unblind failed." };
  }

  const row = (result.rows && result.rows[0]) || {};
  return {
    success: true,
    message: result.message || "Emergency unblind recorded.",
    reveal: {
      kitNumber: row.KitNumber || row.kitNumber || kitNumber,
      productCode: row.ProductCode || row.productCode,
      productName: row.ProductName || row.productName,
      treatmentType: row.TreatmentType || row.treatmentType,
    },
  };
}
